import Store from '@ember-data/store';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';

export default class ReviewItemRoute extends Route {
  @service declare navbarSettings: NavbarSettingsService;
  @service declare store: Store;

  beforeModel() {
    this.navbarSettings.title = 'Review Items';
  }

  async model() {
    return this.store.query('review-item', { filter: { answered: 'false' } });
  }
}
